import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from '../../../../services/message.service'
import { MasterService } from '../../../../services/master.service'
import { StoreService } from '../../../../services/store.service'
import * as languageLibrary from '../../../../services/language'
import { Subject } from 'rxjs';
import { SecurityService } from 'src/app/services/security.service';

@Component({
    selector: 'app-corporations-detail',
    templateUrl: './corporations-detail.component.html',
    styleUrls: ['./corporations-detail.component.scss'],
    standalone: false
})
export class CorporationsDetailComponent implements OnInit {

    // save the language
    protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'

    // set all words
    protected words = languageLibrary.language

    //  data analize
    protected data: any = {}

    // define the corporate type
    protected type: string = ''

    // define the corporate id
    protected id: number = 0

    // define contactId
    protected contactId: number = 0

    // unique identity of the dealer to display, if any.
    protected dealershipId: number = 0;

    // define if is loading
    protected loading: boolean = false

    // define if some field was updated
    protected isGhost: boolean = false

    // error type
    protected error: string = ''

    protected inventoryByCorp

    protected detailInfo: any = {}

    protected addressChangedEvent: Subject<Object> = new Subject();

    /*
    * Life cycles
    */

    constructor(private route: ActivatedRoute, public store: StoreService, private ms: MessageService, private master: MasterService, private security: SecurityService) { }

    ngOnInit() {
        this.type = this.route.snapshot.params['type'] || 'corporation'

        let identity = parseInt(this.route.snapshot.params['id'])
        if (!identity || isNaN(identity) || (identity <= 0)) {
            identity = 0
        }

        this.id = identity

        let dealerId = parseInt(this.route.snapshot.queryParams['dealer'])
        if (!dealerId || isNaN(dealerId) || (dealerId <= 0)) {
            dealerId = 0
        }

        this.dealershipId = dealerId

        if (isNaN(this.id) || (this.id <= 0)) {
            this.id = 0
        }

        if (isNaN(this.contactId) || (this.contactId <= 0)) {
            this.contactId = 0
        }
    }

    /*
    * Functions
    */

    // todo: listen to output of navbar
    protected listenerNav = (e): void => {
        switch (e['message']) {
            case 'changeLanguage':
                this.language = e['value']
                break;
        }
    }

    protected listenerChildrens = (e): void => {
        switch (e.message) {
            case 'setIds':
                this.contactId = e.contactId || 0
                this.id = e.id || 0
                break
            case 'setDetailInfo':
                this.detailInfo = e.detailInfo
                break
        }
    }

    /**
    * Handle address add/change events
    * @param address 
    */
    protected addressChanged = (address): void => {
        this.addressChangedEvent.next(address)
    }

}
